import { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import { PrivateRoute } from 'core/ui/components/private-route/PrivateRoute'
import { useDisableSalesforceChat } from 'core/ui/hooks/useDisableSalesforceChat'
import { PageNotFound } from 'core/ui/router/PageNotFound'

import { useConfigContext } from 'config/ui/ConfigContext'

import BidsPanel from '../bids/ui/BidsPanel'
import { useSaveAllInOneToken } from '../core/ui/hooks/useSaveAllInOneToken'
import ShipperGuideLayout from '../core/ui/layout/shipperguide-layout/ShipperGuideLayout'
import { analytics } from '../core/utils/analytics'
import RfpPage from '../rfp/ui/RfpPage'
import { ShipmentDetails } from '../shipments/ui/ShipmentDetails'
import { ShipperLoadsPage } from '../shipments/ui/ShipperLoadsPage'
import { ShippersPage } from '../shippers/ui/ShippersPage'
import SpotQuotePage from '../spot-quotes/ui/SpotQuotePage'
import TenderListPage from '../tender-list/ui/TenderListPage'
import { TenderPage } from '../tender/ui/TenderPage'

const BASE_PATH = '/all-in-one'

export default function ShipperGuide() {
  useDisableSalesforceChat()
  useSaveAllInOneToken()

  const { enableShipperListPage } = useConfigContext()

  useEffect(() => {
    analytics.init()
  }, [])

  return (
    <ShipperGuideLayout>
      <Switch>
        <PrivateRoute path={`${BASE_PATH}/shipments`} exact>
          <ShipperLoadsPage />
        </PrivateRoute>
        <Route path={`${BASE_PATH}/shipment/:shipmentUUID/:section?`}>
          <ShipmentDetails />
        </Route>
        <Route path={`${BASE_PATH}/bids-list`} exact>
          <BidsPanel />
        </Route>
        <Route path={`${BASE_PATH}/bids/spot-quote`} component={SpotQuotePage} />
        <Route path={`${BASE_PATH}/tender`} exact component={TenderListPage} />
        <Route path={`${BASE_PATH}/tender/:id`} component={TenderPage} />
        <Route path={`${BASE_PATH}/rfp`} component={RfpPage} />
        {enableShipperListPage.toBoolean() && (
          <Route path={`${BASE_PATH}/shippers`} component={ShippersPage} />
        )}
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </ShipperGuideLayout>
  )
}
